import { extname } from 'path'
import toast from 'react-hot-toast'
import { ChaingeChain, ChaingeToken } from 'types/baseType'
import { DEF_TOKEN_ADDRESS } from 'utils'
import request from 'utils/request'

// 获取资产列表
export interface ApiBalanceParams {
    chain: string
    address: string
    contractAddress: string
}
export const getEvmBalance = async (params: ApiBalanceParams) => {
    const {code = -1, data = {}}: any = await request.get('/getBalance', {
        params: params
    })
    if(code === 0) {
        return data.hrpBalance
    }
    return '0.0'
}

// 获取资产价格
export interface ApiPriceParams {
    chain: string
    symbol: string
    contractAddress: string
}
export const getEvmPrice = async (params: ApiPriceParams) => {
    const {code = -1, data = {}}: any = await request.get('/getPrice', {
        params: params
    })
    if(code === 0) {
        return data.price
    }
    return '0'
}


// 获取Aggregate交易询价列表
interface ApiCheckSupportParams {
    fromChain: ChaingeChain
    toChain: ChaingeChain
    fromToken: ChaingeToken
    toToken: ChaingeToken
}
export const checkAggregateSupportedToken = async (params: ApiCheckSupportParams) => {
   try {
        const {code = -1, data = {}}: any = await request.get('/getAggregateSupportedToken')
        if(code === 0) {
            const { fromToken, toToken } = params
            const fromTokenSymbol = fromToken?.symbol
            const toTokenSymbol = toToken?.symbol

            const supportChainList = data.chains
            const keyChains: string[] = []
            supportChainList.forEach((item: any) => {
                keyChains.push(item.chainId)
            });
            const tokenObj: any = {}
            supportChainList.forEach((item: any) => {
                const tokens = item.tokens
                tokens.forEach((tokenItem: any) => {
                    tokenObj[tokenItem.symbol] = 1
                });
            });
            const tokenKeys = Object.keys(tokenObj)

            let isMainToken = false
            if(tokenKeys.includes(fromTokenSymbol) && tokenKeys.includes(toTokenSymbol)) {
                isMainToken = true
            }
            return {
                supportChains: keyChains,
                isMainToken
            }
            
 
            // const supportChainList = data.chains
            // let supportChain = -1;  // 0 都不支持 1 链支持 2 链和token都支持
            // let supportToken = -1;  // 0 都不支持 1 链支持 2 链和token都支持

            // const tempFromChain = supportChainList.find((item: any) => item.chainId === fromChain.network)
            // if(!tempFromChain || (tempFromChain && tempFromChain.tokens && tempFromChain.tokens.length === 0)) {
            //     supportChain = 0
            // }

            // const tempToChain = supportChainList.find((item: any) => item.chainId === toChain.network)
            // if(!tempToChain || (tempToChain && tempToChain.tokens && tempToChain.tokens.length === 0)) {
            //     supportChain = 0
            // }
            // if(supportChain === 0) {
            //     return supportChain
            // }

            // supportChain = 1

            // const tempFromToken = tempFromChain.tokens.find((item: any) => item.symbol === fromToken.symbol)
            // if(!tempFromToken) {
            //     supportToken = 0;
            // }

            // const tempToToken = tempToChain.tokens.find((item: any) => item.symbol === toToken.symbol)
            // if(!tempToToken) {
            //     supportToken = 0
            // }
            // if(supportToken === -1) {
            //     supportToken = 1
            // }
            // return supportToken + supportChain
        }
   } catch(error) {
        throw error
   }
}

interface ApiAggregateQuoteMainTokenParams {
    fromSymbol: string
    toSymbol: string
    fromAmount: string
}
export const getAggregateQuoteMainToken = async (params: ApiAggregateQuoteMainTokenParams, fromChainId: string, toChainId: string) => {
    try {
        const {code = -1, data = {}}: any = await request.get('/getAggregateQuoteMainToken', {params})
        if(code === 0) {
            const bestList = data?.best || []
            const otherList = data?.others || []
            if(bestList.length) {
                const fromRouterInfo = bestList.find((item : any) => item?.chainId === fromChainId)
                if(fromRouterInfo) {
                    return fromRouterInfo
                }
                const toRouterInfo = bestList.find((item : any) => item?.chainId === toChainId)
                if(toRouterInfo) {
                    return toRouterInfo
                }
            }
            if(otherList.length) {
                const fromRouterInfo = otherList.find((item : any) => item?.chainId === fromChainId)
                if(fromRouterInfo) {
                    return fromRouterInfo
                }
                const toRouterInfo = otherList.find((item : any) => item?.chainId === toChainId)
                if(toRouterInfo) {
                    return toRouterInfo
                }
            }
            return undefined
        }
    } catch(error) {
        throw error
    }
}

interface ApiAggregateQuoteTokenAddress {
    chain: string
    fromToken: string
    toToken: string
    fromDecimals: number
    toDecimals: number
    fromAmount: string
}
export const getAggregateQuoteTokenAddress = async (params:ApiAggregateQuoteTokenAddress, chainId: string) => {
    try {
        const {code = -1, data = {}}: any = await request.get('/getAggregateQuoteTokenAddress', {params})
        if(code === 0) {
            const bestList = data?.best || []
            const otherList = data?.others || []
            if(bestList.length) {
                const routerInfo = bestList.find((item : any) => item?.chainId === chainId)
                if(routerInfo) {
                    return routerInfo
                }
            }
            if(otherList.length) {
                const routerInfo = otherList.find((item : any) => item?.chainId === chainId)
                if(routerInfo) {
                    return routerInfo
                }
            }
            return undefined
        }
    } catch(error) {
        return undefined
    }
}


interface ApiAggregateSwapParams {
    chain: string
    aggregator: string
    fromToken: string
    toToken: string
    fromAmount: string
    fromAddress: string
    receiver: string
    slippage: number
    allowPartialFill: boolean
    routeSummary: string
    fromTokenDecimal: string
    toTokenDecimal: string
}
export const getAggregateSwap = async (params: ApiAggregateSwapParams) => {
    try {
        const result: any = await request.get('/getAggregateSwap', {params})
        return result
    } catch(error) {
        throw error
    }
}


interface ApiSubmitOrderParams {
    sourceCerts: string
    orderType: string
    toIndex: string
    slippage?: string
    triggerPrice?: string
    timeout?: string
    toChain: string
    toAddr: string
    execStrategy?: string
    extra?: string
}
export const postSubmitOrder = async (params: ApiSubmitOrderParams, headers: {[key:string]: any}) => {
    try {
        const {code = -1, data = {}}: any = await request.post('/submitOrder', params, {
            headers: headers
        })
        if(code === 0) {
            toast.success('successfully', {
                duration: 3000,
                position: 'top-right',
            })
        }
    } catch(error) {
        throw error
    }
}

// https://api2.chainge.finance/v1/getAssetsByChain?chain=FSN
export const getAssetsByChainBase = async (chainName: string, toTokenName: string) => {
    try {
        const params = {
            chain: chainName
        }
        const {code = -1, data = {}}: any = await request.get('/getAssetsByChain', { params })
        if(code === 0) {
            const list = data.list
            const baseToken = list.find((item: any) => item.symbol === toTokenName)
            return baseToken
        }
    } catch(error) {
        throw error
    }
}

export const sortParams = (params: {[key:string]: any}, evmAddress: string) => {
    let keys = Object.keys(params)
    if(!keys.length) return undefined
    keys = keys.sort();
    const keyValList = []
    for (const key of keys) {
        const val = params[key];
        if(val) {
            keyValList.push(`${key}=${val}`)
        }
    }
    const data = keyValList.join('&')
    const raw = `EvmAddress=${evmAddress}&${data}`
    return raw
}